import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {
  @Input() question!: any;
  @Input() eachControl!: any;
  @Input() controlIndex!: number;
  @Input() form!: FormGroup;
  @Input() assessmentType!: string;
  @Output() inputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() isSubmittedEvent!: Observable<void>;
  saveNextSubject: Subject<void> = new Subject<void>();

  constructor(private assessmentService: AssessmentService, private commonService: CommonService,
    private activateRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.isSubmittedEvent.subscribe(() => {
      this.saveNextSubject.next();
    });
    this.activateRoute.queryParams.subscribe((queryParam: any) => {
      if (queryParam.hasOwnProperty('action') && queryParam.action == 'view') {
        this.eachControl.isDisabled = true;
      }
    });
    if (this.eachControl?.isCountryDropdown && this.eachControl.countryType) {
      this.generateCountry();
    }
  }

  generateCountry() {
    this.eachControl.options = [];
    const rqstBody = {
      countryType: this.eachControl.countryType
    }
    this.assessmentService.fetchCountryList(rqstBody).subscribe((res) => {
      let decryptedData = this.commonService.decryptUsingAES256(res?.data);
      let resp = JSON.parse(JSON.stringify(decryptedData));
      // console.log('finally country list in control assessment: ', resp);
      let allCountries = resp.countryList;
      if (this.eachControl.type == 'multiselect') {
        allCountries?.forEach((opt: any, k: any) => {
          this.eachControl.options.push({ key: k, value: opt.countryname, valueArabic: opt.countryname, checked: false });
        });
      } else {
        allCountries?.forEach((opt: any, k: any) => {
          this.eachControl.options.push({ key: k, value: opt.countryname, valueArabic: opt.countryname });
        });
      }
    });
  }

  populatingMultiselect() {
    if (this.eachControl.type == 'multiselect') {
      this.eachControl?.options.forEach((element: any, idx: any) => {
        this.eachControl.options[idx].checked = true;
      });
    }
  }

  valueChanged(parentQuesAns: any) {
    // console.log('in ques component: ', parentQuesAns);
    this.inputChanged.emit(parentQuesAns);
  }

}
